import { fetchListVerificacion } from "../http-common";
import {
  IPersonaEquipo,
  IEquipoModelo,
  IModeloEquipoCombo,
} from "../../Interfaces/IListaVerificacion";
import tokenService from "../tokenService";
import { Ifilter } from "../../Interfaces/filter";
import {
  IModeloDispositovoPorPersona,
  IModeloEquipoDelete,
} from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";

const grupos = "GrupoVerficacion";
const equipos = "Equipo";

const allEquipo = (equipoModeloId: string) => {
  return fetchListVerificacion.get(`Equipo${equipoModeloId}`);
};

const allEquipoModelo = (data: IModeloDispositovoPorPersona) => {
  return fetchListVerificacion.post("EquipoModelo", data);
};
const postEquipoHistorico = (id: string) => {
  return fetchListVerificacion.post(`Equipo/Historico/${id}`);
};

const allPersonaEquipos = (personaId: string) => {
  //falta api
  return fetchListVerificacion.get(`AutorizacionEquipoModelo/${personaId}`);
};

const postPersonaEquipo = (data: IPersonaEquipo) => {
  return fetchListVerificacion.post(`AutorizacionEquipoModelo`, data);
};

const eliminarEquipo = (id: string, personaId: string) => {
  return fetchListVerificacion.delete<string>(
    `AutorizacionEquipoModelo/Eliminar/perdonaId${personaId}/${id}`
  );
};

const GetGruposdeVerificacion = () => {
  return fetchListVerificacion.get(`${grupos}/ListaGrupos`);
};
const propiedadesVerificacionByGrupo = (grupoVerificacionId: string) => {
  return fetchListVerificacion.get(
    `${grupos}/PropiedadesByGrupo?GrupoVerificacionId=${grupoVerificacionId}`
  );
};
const comboEquipos = (filters: Ifilter) => {
  return fetchListVerificacion.get(`${equipos}`, { params: filters });
};

const autorizacionesPorPersona = (data: any) => {
  return fetchListVerificacion.post(
    `AutorizacionEquipoModelo/AutorizacionesPorPersona`,
    data
  );
};

const putEliminarModeloEquipoPersona = (data: IModeloEquipoDelete) => {
  return fetchListVerificacion.put(
    "AutorizacionEquipoModelo/EliminiarModeloEquipoPersona",
    data
  );
};

const postListarCheckListPorSupervisor = (
  data: any,
  controller = new AbortController()
) => {
  return fetchListVerificacion.post(
    "ListaVerificacion/ListarCheckListPorSupervisor",
    data,
    { signal: controller.signal }
  );
};

const EquipoModeloCombo = (data: any) => {
  return fetchListVerificacion.post("EquipoModelo/ListarCombo", data);
};

const listaVerificacionServicio = {
  allEquipo,
  postEquipoHistorico,
  allEquipoModelo,
  postPersonaEquipo,
  allPersonaEquipos,
  eliminarEquipo,
  GetGruposdeVerificacion,
  propiedadesVerificacionByGrupo,
  comboEquipos,
  autorizacionesPorPersona,
  putEliminarModeloEquipoPersona,
  postListarCheckListPorSupervisor,
  EquipoModeloCombo,
};

export default listaVerificacionServicio;
